import * as React from 'react';
import { FieldProps, StateProps } from './props';

export class RadioSelect extends React.Component<FieldProps, StateProps> {
  constructor(props: FieldProps) {
    super(props);
    this.state = {
      value: this.props.defaultValue,
    };
    this.handleChange = this.handleChange.bind(this);
  }

  public componentDidUpdate(prevProps: FieldProps) {
    if (prevProps.defaultValue !== this.props.defaultValue) {
      this.updateDefault();
    }
  }

  public updateDefault() {
    if (this.props.defaultValue !== undefined) {
      this.setState({ value: this.props.defaultValue });
    }
  }

  public handleChange(event: { target: { value: string } }) {
    const value =
      this.props.type === 'boolean'
        ? event.target.value === 'true'
          ? true
          : false
        : event.target.value;
    this.setState({ value });
    this.props.onChange?.(value);
  }
  public render() {
    const {
      name,
      label,
      options,
      optionLabel,
      optionValue,
      paddingClass,
    } = this.props;
    const padding = paddingClass || 'pr-2';
    return (
      <React.Fragment>
        {label && <label className="font-sm text-uppercase">{label}</label>}

        <div className="font-weight-normal d-flex py-1">
          {options.map((option) => {
            return (
              <div
                className={`mr-4 agency ${padding}`}
                key={option[optionValue || '']}
              >
                <input
                  type="radio"
                  id={`${name}-${option[optionValue || '']}`}
                  name={name}
                  value={option[optionValue || '']}
                  checked={option[optionValue || ''] === this.state.value}
                  onChange={this.handleChange}
                  ref={(input) => input && input.focus()}
                  disabled={this.props.disabled}
                />
                <label htmlFor={`${name}-${option[optionValue || '']}`}>
                  {option[optionLabel || '']}
                </label>
              </div>
            );
          })}
        </div>
      </React.Fragment>
    );
  }
}

export default RadioSelect;
